import { PathBase } from "@constellation-academy/epic-ui";

export class AcademiesTagsPath extends PathBase {
	static readonly pathKey = "tags";
}
